import apiClient from '@/lib/apiClient';
import { buildListParams, extractPaginatedData } from '@/shared/utils/queryUtils';
import type { ListParams, PaginatedData, District, DistrictFormData, Country, Region, City } from '@/shared/types';

const BASE = '/admin/districts';

export const districtApi = {
  list: async (params: ListParams): Promise<PaginatedData<District>> => {
    const queryParams = buildListParams(params);
    const res = await apiClient.get(BASE, { params: queryParams });
    return extractPaginatedData(res);
  },

  getById: async (id: string | number): Promise<District> => {
    const res = await apiClient.get(`${BASE}/${id}`);
    return res.data?.data;
  },

  create: async (data: DistrictFormData): Promise<District> => {
    const res = await apiClient.post(BASE, data);
    return res.data?.data;
  },

  update: async (id: string | number, data: DistrictFormData): Promise<District> => {
    const res = await apiClient.patch(`${BASE}/${id}`, data);
    return res.data?.data;
  },

  delete: async (id: string | number): Promise<void> => {
    const res = await apiClient.delete(`${BASE}/${id}`);
    return res.data;
  },

  listCountries: async (): Promise<Country[]> => {
    const res = await apiClient.get('/admin/countries/all');
    return res.data?.data;
  },

  listRegionsByCountry: async (countryId: number): Promise<Region[]> => {
    const res = await apiClient.get(`/admin/regions/by-country/${countryId}`);
    return res.data?.data;
  },

  listCitiesByRegion: async (regionId: number): Promise<City[]> => {
    const res = await apiClient.get(`/admin/cities/by-region/${regionId}`);
    return res.data?.data;
  },

  listByCity: async (cityId: number | string): Promise<District[]> => {
    const res = await apiClient.get(`${BASE}/by-city/${cityId}`);
    return res.data?.data ?? [];
  },
};
